import reportBuilder from './reportBuilder';
import reportDetails from './reportDetails';
import workbookDetails from './workbookDetails';

export default {
	modules: {
		reportBuilder,
		reportDetails,
		workbookDetails,
	},
};
